/**
 * SmartRural Sync API
 * API para sincronizar los datos de Smartrural entre la aplciación móvil y el servidor.
 *
 * OpenAPI spec version: 1.1.4
 * Contact: victor@aidiapp.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { EditableFrameLink } from '../model/editableFrameLink';
import { FrameLink } from '../model/frameLink';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FramelinksService {

  protected basePath = 'https://api.smartrural.es:8084/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create framelink from company (Only for superAdmin)
     *
     * @param idcompany IdCompany to get users from
     * @param framelink Framelink data to create
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createframelink(idcompany: number, framelink: EditableFrameLink, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<EditableFrameLink>;
    public createframelink(idcompany: number, framelink: EditableFrameLink, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditableFrameLink>>;
    public createframelink(idcompany: number, framelink: EditableFrameLink, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditableFrameLink>>;
    public createframelink(idcompany: number, framelink: EditableFrameLink, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcompany === null || idcompany === undefined) {
            throw new Error('Required parameter idcompany was null or undefined when calling createframelink.');
        }

        if (framelink === null || framelink === undefined) {
            throw new Error('Required parameter framelink was null or undefined when calling createframelink.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<EditableFrameLink>(`${this.basePath}/company/${encodeURIComponent(String(idcompany))}/framelink`,
            framelink,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete Framelink (Only for superAdmin)
     *
     * @param idcompany IdCompany to delete framelink from
     * @param idframelink IdFramelink to delete
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteframelink(idcompany: number, idframelink: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<EditableFrameLink>;
    public deleteframelink(idcompany: number, idframelink: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditableFrameLink>>;
    public deleteframelink(idcompany: number, idframelink: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditableFrameLink>>;
    public deleteframelink(idcompany: number, idframelink: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcompany === null || idcompany === undefined) {
            throw new Error('Required parameter idcompany was null or undefined when calling deleteframelink.');
        }

        if (idframelink === null || idframelink === undefined) {
            throw new Error('Required parameter idframelink was null or undefined when calling deleteframelink.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<EditableFrameLink>(`${this.basePath}/company/${encodeURIComponent(String(idcompany))}/framelink/${encodeURIComponent(String(idframelink))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get framelink list from company (Only for superAdmin)
     *
     * @param idcompany IdCompany to get framelinks from
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public framelinksfromcompany(idcompany: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FrameLink>>;
    public framelinksfromcompany(idcompany: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FrameLink>>>;
    public framelinksfromcompany(idcompany: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FrameLink>>>;
    public framelinksfromcompany(idcompany: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcompany === null || idcompany === undefined) {
            throw new Error('Required parameter idcompany was null or undefined when calling framelinksfromcompany.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<FrameLink>>(`${this.basePath}/company/${encodeURIComponent(String(idcompany))}/framelink`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get framelink list from own company (Only for Managers)
     *
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public framelinksfromowncompany(authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<FrameLink>>;
    public framelinksfromowncompany(authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FrameLink>>>;
    public framelinksfromowncompany(authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FrameLink>>>;
    public framelinksfromowncompany(authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<FrameLink>>(`${this.basePath}/company/framelink`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get framelink  from company (Only for superAdmin)
     *
     * @param idcompany IdCompany to get framelink from
     * @param idframelink IdFRamelink to get
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getsingleframelink(idcompany: number, idframelink: number, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<EditableFrameLink>;
    public getsingleframelink(idcompany: number, idframelink: number, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditableFrameLink>>;
    public getsingleframelink(idcompany: number, idframelink: number, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditableFrameLink>>;
    public getsingleframelink(idcompany: number, idframelink: number, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcompany === null || idcompany === undefined) {
            throw new Error('Required parameter idcompany was null or undefined when calling getsingleframelink.');
        }

        if (idframelink === null || idframelink === undefined) {
            throw new Error('Required parameter idframelink was null or undefined when calling getsingleframelink.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EditableFrameLink>(`${this.basePath}/company/${encodeURIComponent(String(idcompany))}/framelink/${encodeURIComponent(String(idframelink))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update Framelink (Only for superAdmin)
     *
     * @param idcompany IdCompany to update framelink from
     * @param idframelink IdFramelink to update
     * @param user Framelink data to update
     * @param authorization Access token in the format Bearer token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateframelink(idcompany: number, idframelink: number, user: EditableFrameLink, authorization?: string, observe?: 'body', reportProgress?: boolean): Observable<EditableFrameLink>;
    public updateframelink(idcompany: number, idframelink: number, user: EditableFrameLink, authorization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditableFrameLink>>;
    public updateframelink(idcompany: number, idframelink: number, user: EditableFrameLink, authorization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditableFrameLink>>;
    public updateframelink(idcompany: number, idframelink: number, user: EditableFrameLink, authorization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idcompany === null || idcompany === undefined) {
            throw new Error('Required parameter idcompany was null or undefined when calling updateframelink.');
        }

        if (idframelink === null || idframelink === undefined) {
            throw new Error('Required parameter idframelink was null or undefined when calling updateframelink.');
        }

        if (user === null || user === undefined) {
            throw new Error('Required parameter user was null or undefined when calling updateframelink.');
        }


        let headers = this.defaultHeaders;
        if (authorization !== undefined && authorization !== null) {
            headers = headers.set('Authorization', String(authorization));
        }

        // authentication (authtoken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<EditableFrameLink>(`${this.basePath}/company/${encodeURIComponent(String(idcompany))}/framelink/${encodeURIComponent(String(idframelink))}`,
            user,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
